"use client";

import CreditCard from "@mui/icons-material/CreditCard";
import FavoriteBorder from "@mui/icons-material/FavoriteBorder";
import Person from "@mui/icons-material/Person";
import Place from "@mui/icons-material/Place";
import ShoppingBagOutlined from "@mui/icons-material/ShoppingBagOutlined";
import { usePathname } from "next/navigation";
import { Fragment } from "react"; // MUI ICON COMPONENTS
import {
  Paragraph,
  Span,
} from "src/lib/components/salify-next-layout/default/components/Typography"; // CUSTOM ICON COMPONENT
import { FlexBox } from "src/lib/components/salify-next-layout/default/components/flex-box";
import CustomerService from "src/lib/components/salify-next-layout/default/icons/CustomerService";
import { MainContainer, StyledNavLink } from "./styles";

const Navigation = ({ menu }) => {
  const pathname = usePathname();

  const renderIcon = (type) => {
    switch (type) {
      case "order":
        return <ShoppingBagOutlined color="inherit" fontSize="small" className="nav-icon" />;
      case "wishlist":
        return <FavoriteBorder color="inherit" fontSize="small" className="nav-icon" />;
      case "support":
        return <CustomerService color="inherit" fontSize="small" className="nav-icon" />;
      case "profile":
        return <Person color="inherit" fontSize="small" className="nav-icon" />;
      case "address":
        return <Place color="inherit" fontSize="small" className="nav-icon" />;
      case "payment":
        return <CreditCard color="inherit" fontSize="small" className="nav-icon" />;
    }
    return null;
  };

  return (
    <MainContainer>
      {menu.map((item) => (
        <Fragment key={item.title}>
          <Paragraph p="26px 30px 1rem" color="grey.600" fontSize={12}>
            {item.title}
          </Paragraph>

          {item.list.map(({ type, count, href, title }) => (
            <StyledNavLink href={href} key={title} isCurrentPath={pathname.includes(href)}>
              <FlexBox alignItems="center" gap={1}>
                {renderIcon(type)}
                <Span>{title}</Span>
              </FlexBox>

              <Span>{count}</Span>
            </StyledNavLink>
          ))}
        </Fragment>
      ))}
    </MainContainer>
  );
};

export default Navigation;
